import styled from '@emotion/styled';

import LOGO from '@hotjar/shared-assets/images/logo-hotjar.svg';

const ImgWrapper = styled.div`
  display: block;
  height: 24px;
`;

const Img = styled.img`
  height: 100%;
`;

export const Logo = (): JSX.Element => {
  return (
    <ImgWrapper>
      <Img src={LOGO} alt="Hotjar" />
    </ImgWrapper>
  );
};
